const productsConfig = {
    "company": "Value Added Coating Solution Pvt Ltd",
    "products": [
        {
            "category": {
                "display_name": "Coating Plants",
                "slug": "coating_plants",
                "type": "category"
            },
            "items": [
                {
                    "category": {
                        "display_name": "Powder Coating Plant",
                        "slug": "powder_coating_plant",
                        "type": "sub_category"
                    },
                    "items": [
                        {
                            "display_name": "Manual Powder Coating Plant",
                            "slug": "manual_powder_coating_plant"
                        },
                        {
                            "display_name": "Semi-Automatic Powder Coating Plant",
                            "slug": "semi_automatic_powder_coating_plant"
                        },
                        {
                            "display_name": "Automatic Powder Coating Plant",
                            "slug": "automatic_powder_coating_plant"
                        },
                        {
                            "display_name": "Pollution-Free Powder Coating Plant",
                            "slug": "pollution_free_powder_coating_plant"
                        }
                    ]
                },
                {
                    "category": {
                        "display_name": "Liquid Painting Plant",
                        "slug": "liquid_painting_plant",
                        "type": "sub_category"
                    },
                    "items": [
                        {
                            "display_name": "Manual Liquid Painting Plant",
                            "slug": "manual_liquid_painting_plant"
                        },
                        {
                            "display_name": "Automatic Liquid Painting Plant",
                            "slug": "automatic_liquid_painting_plant"
                        }
                    ]
                },
            ]
        },

        {
            "category": {
                "display_name": "Coating Booths",
                "slug": "coating_booths",
                "type": "category"

            },
            "items": [
                {
                    "category": {
                        "display_name": "Powder Coating Booths",
                        "slug": "powder_coating_booths",
                        "type": "sub_category"
                    },
                    "items": [
                        {
                            "display_name": "Single Operator Pollution Free Powder Coating Booth",
                            "slug": "single_operator_pollution_free_powder_coating_booth"
                        },
                        {
                            "display_name": "Double Operator Pollution Free Powder Coating Booth",
                            "slug": "double_operator_pollution_free_powder_coating_booth"
                        },
                        {
                            "display_name": "Automatic Powder Coating Booth (Stainless Steel)",
                            "slug": "automatic_powder_coating_booth_stainless_steel"
                        },
                        {
                            "display_name": "Automatic Powder Coating Booth (Plastic)",
                            "slug": "automatic_powder_coating_booth_plastic"
                        },
                        {
                            "display_name": "Pollution-Free Powder Coating Booth for Big Components (Jumbo Booth)",
                            "slug": "jumbo_pollution_free_powder_coating_booth"
                        }
                    ]
                },
                {
                    "category": {
                        "display_name": "Liquid Painting Booths",
                        "slug": "liquid_painting_booth",
                        "type": "sub_category"
                    },
                    "items": [
                        {
                            "display_name": "Water Curtain Spray Booth",
                            "slug": "water_curtain_spray_booth"
                        },
                        {
                            "display_name": "Dry Spray Booth",
                            "slug": "dry_spray_booth"
                        },
                        {
                            "display_name": "Car Paint Booth",
                            "slug": "car_paint_booth"
                        }
                    ]
                },
            ]
        },

        {
            "category": {
                "display_name": "Curing Ovens",
                "slug": "curing_ovens",
                "type": "category"
            },
            "items": [
                {
                    "display_name": "Batch Type Oven",
                    "slug": "batch_type_oven"
                },
                {
                    "display_name": "Overhead Conveyor Oven",
                    "slug": "overhead_conveyor_oven"
                },
                {
                    "display_name": "Belt Conveyor Oven",
                    "slug": "belt_conveyor_oven"
                },
                {
                    "display_name": "Water Dry Oven",
                    "slug": "water_dry_oven"
                },
                {
                    "display_name": "Powder Curing Oven",
                    "slug": "powder_curing_oven"
                },
                {
                    "display_name": "Paint Curing Oven",
                    "slug": "paint_curing_oven"
                },
                {
                    "display_name": "Varnish Curing Oven",
                    "slug": "varnish_curing_oven"
                },
                {
                    "display_name": "Wood Finish Oven",
                    "slug": "wood_finish_oven"
                }
            ]
        },
        {
            "category": {
                "display_name": "Pre-Treatment Plant",
                "slug": "pre_treatment_plant",
                "type": "category"
            },
            "items": [
                {
                    "display_name": "Dip PT Line",
                    "slug": "dip_pt_line"
                },
                {
                    "display_name": "Spray PT Line",
                    "slug": "spray_pt_line"
                }
            ]
        },
        {
            "category": {
                "display_name": "Conveyors",
                "slug": "conveyors",
                "type": "category"
            },
            "items": [
                {
                    "display_name": "5 T Enclosed Overhead Conveyor",
                    "slug": "5t_enclosed_overhead_conveyor"
                },
                {
                    "display_name": "7 T Enclosed Overhead Conveyor",
                    "slug": "7t_enclosed_overhead_conveyor"
                },
                {
                    "display_name": "Four Wheel Type Conveyor",
                    "slug": "four_wheel_type_conveyor"
                },
                {
                    "display_name": "I Beam Model Conveyor",
                    "slug": "i_beam_model_conveyor"
                },
                {
                    "display_name": "Belt Conveyor",
                    "slug": "belt_conveyor"
                }
            ]
        },
        {
            "category": {
                "display_name": "Spray Guns",
                "slug": "spray_guns",
                "type": "category"
            },
            "items": [
                {
                    "category": {
                        "display_name": "Powder Spray Guns",
                        "slug": "powder_spray_guns",
                        "type": "sub_category"
                    },
                    "items": [
                        {
                            "display_name": "Manual Powder Spray Gun",
                            "slug": "manual_powder_spray_gun"
                        },
                        {
                            "display_name": "Automatic Powder Spray Guns",
                            "slug": "automatic_powder_spray_guns"
                        }
                    ]
                },
                {
                    "category": {
                        "display_name": "Liquid Spray Guns",
                        "slug": "liquid_spray_guns",
                        "type": "sub_category"
                    },
                    "items": [
                        {
                            "category": {
                                "display_name": "Manual Spray Gun",
                                "slug": "manual_spray_gun",
                                "type": "sub_category_inner"
                            },
                            "items": [
                                {
                                    "display_name": "Cup Gun",
                                    "slug": "cup_gun"
                                },
                                {
                                    "display_name": "Electrostatic Spray Gun",
                                    "slug": "electrostatic_spray_gun"
                                },
                                {
                                    "display_name": "HVLP Spray Gun",
                                    "slug": "hvlp_spray_gun"
                                },
                                {
                                    "display_name": "Air Assist Gun",
                                    "slug": "air_assist_gun"
                                },
                                {
                                    "display_name": "Air Less Gun",
                                    "slug": "air_less_gun"
                                },
                            ]
                        },
                        {
                            "display_name": "Automatic Spray Guns",
                            "slug": "automatic_spray_guns"
                        }
                    ]
                },
            ]
        },
        {
            "category": {
                "display_name": "Dust Collector",
                "slug": "dust_collector",
                "type": "category"
            },
            "items": [
                {
                    "display_name": "Dust Collector (3000 – 32,000 CMH)",
                    "slug": "dust_collector_3000_32000_cmh"
                }
            ]
        },
        {
            "category": {
                "display_name": "Cyclone",
                "slug": "cyclone",
                "type": "category"
            },
            "items": [
                {
                    "display_name": "Cyclone (3000 – 32,000 CMH)",
                    "slug": "Cyclone_3000_32000_cmh"
                }
            ]
        },
        {
            "category": {
                "display_name": "Powder Sieving System (PS-2 and others)",
                "slug": "powder_sieving_system",
                "type": "category"
            },
            "items": [
                {
                    "display_name": "Multiple variety (PS-2 etc.)",
                    "slug": "multiple_variety"
                }
            ]
        },
        {
            "category": {
                "display_name": "Other Equipment",
                "slug": "other_equipment",
                "type": "category"
            },
            "items": [
                {
                    "display_name": "Hopper",
                    "slug": "hopper"
                },
                {
                    "display_name": "Electrical Cabinets",
                    "slug": "electrical_cabinets"
                },

                {
                    "display_name": "Cyclone",
                    "slug": "cyclone"
                }
            ]
        },

        {
            "category": {
                "display_name": "Material Handling Equipment",
                "slug": "material_handling_equipment",
                "type": "category"
            },
            "items": [
                {
                    "display_name": "Wire Rope Hoist",
                    "slug": "wire_rope_hoist"
                },
                {
                    "category": {
                        "display_name": "Transporter",
                        "slug": "transporter",
                        "type": "sub_category"
                    },
                    "items": [
                        {
                            "display_name": "Manual Transporter",
                            "slug": "manual_transporter"
                        },
                        {
                            "display_name": "Automatic Transporter",
                            "slug": "automatic_transporter"
                        }
                    ]
                },

            ]
        }
    ]
}

export default productsConfig;